import React, {lazy, Suspense} from 'react';
import {Route, Routes} from 'react-router-dom';
import LandingPage from './Public/LandingPage/LandingPage';

// Landing page is the homepage — eager. Everything else is lazy so MUI,
// moment-timezone and other heavy deps don't bloat the LandingPage chunk.
const IntegrityPolicyPage = lazy(() => import('./Public/IntegrityPolicy/IntegrityPolicyPage'));
const CookiePolicyPage = lazy(() => import('./Public/CookiePolicy/CookiePolicyPage'));
const DeliveryStatusPage = lazy(() => import('./Public/DeliveryStatus/DeliveryStatusPage'));
const ClaimStatusPage = lazy(() => import('./Public/ClaimStatusPage/ClaimStatusPage'));

function PublicApp() {
	return (
		<Suspense fallback={null}>
			<Routes>
				<Route path={'/'} element={<LandingPage />} />
				<Route path="/start" element={<LandingPage />} />
				<Route path="/landing" element={<LandingPage />} />
				<Route path="/:locale" element={<LandingPage />} />
				<Route path="gdpr" element={<IntegrityPolicyPage />} />
				<Route path="cookies" element={<CookiePolicyPage />} />
				<Route path="/claimstatus/:token" element={<ClaimStatusPage />} />
				<Route path="/deliverystatus/:token" element={<DeliveryStatusPage />} />
			</Routes>
		</Suspense>
	);
}

export default PublicApp;
